import { useContent } from "../ContentContext";
import DarkFooter from "../sections/DarkFooter";

const NotFound = () => {
  const content = useContent();

  return (
    <div className="bg-dark text-light h-screen flex flex-col">

      {/* Homepage Section */}
      <section className="relative h-full text-center bg-light text-white flex-grow">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/homepage.png"
        >
          <source src="/videos/homepage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Layer */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/70 via-dark/70 to-dark"></div>

        {/* Overlay Content */}
        <div className="relative max-w-4xl mx-auto flex flex-col items-center justify-center h-full">
          {/* Text Content */}
          <p className="uppercase text-2xl tracking-wide font-garet relative">
            {content.notfoundpage.subtitle}
          </p>
          <h1 className="text-7xl my-4 font-bodoni relative">{content.notfoundpage.title}</h1>
        </div>
      </section>

     
      {DarkFooter()}
      
      
    </div>
  );
};

export default NotFound;